import { useState } from 'react';

const About = () => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const values = [
    {
      number: '01',
      title: 'Brand Experience',
      subtitle: 'ブランドの輝きを最大化',
      description: 'ブランドの輝きを最大化し、洗練された空間演出をします。',
      details: [
        {
          name: 'ロンチパーティー',
          text: '単なるパーティーではなく、ブランドのフィロソフィーを視覚・聴覚・味覚で演出します',
        },
        {
          name: 'ガラパーティー',
          text: 'ドレスコードの設定から、会場の装飾、進行演出までをトータルプロデュース',
        },
        {
          name: 'ドレスショー',
          text: 'ジュエリーやファッションの魅力を最大化する空間作り',
        },
      ],
    },
    {
      number: '02',
      title: 'VIP Hospitality',
      subtitle: 'VIPに優越感と感動を届ける',
      description: 'すべてのプロジェクトはゼロから設計。クライアントのビジョンを唯一無二の形に昇華させます。',
      details: [
        {
          name: 'セレブリティーパーティー',
          text: '国内外問わずウェディング、バースデー記念日パーティープロデュース',
        },
        {
          name: 'ブランドのVIP顧客向け企画',
          text: '高級車オーナーや特別顧客向けの少人数イベント',
        },
        {
          name: 'インセンティブ旅行',
          text: '深い信頼関係と長く続くロイヤリティを育む旅企画',
        },
      ],
    },
    {
      number: '03',
      title: 'Global & Cultural Curation',
      subtitle: 'インバウンドに本物の日本をデザインする',
      description: '日本の伝統と現代の感性を融合させ、国内外のゲストに深く響く文化体験を創造します。',
      details: [
        {
          name: 'プライベート・カルチャー',
          text: '茶会や、歴史的建造物を貸し切った特別なレセプション',
        },
        {
          name: 'モダン・アレンジ',
          text: '伝統芸能や着物文化を洗練された演出で提供',
        },
        {
          name: 'バイリンガル・ホスピタリティ',
          text: '海外VIPの細かなニーズを熟知したスタッフによる、ストレスのない運営',
        },
      ],
    },
    {
      number: '04',
      title: 'Corporate Events',
      subtitle: '企業の結束と未来を祝う',
      description: '富裕層・企業との長期的なパートナーシップを大切にし、期待を超える成果をお届けします。',
      details: [
        {
          name: '総会',
          text: '経営層のプレゼンテーションを最大化するステージ演出と、淀みのない進行',
        },
        {
          name: 'キックオフ',
          text: '新ブランドの立ち上げや組織変更に伴う、エネルギーに満ちた決起集会を運営',
        },
        {
          name: '周年パーティー',
          text: 'ストーリーテリングや、企業のアイデンティティを散りばめたレセプション企画',
        },
      ],
    },
  ];

  const handleToggle = (number: string) => {
    setExpandedId(prev => (prev === number ? null : number));
  };

  return (
    <section id="about" className="py-32" style={{ backgroundColor: '#FAF7F2' }}>
      <div className="max-w-7xl mx-auto px-8">

        {/* セクションヘッダー */}
        <div className="mb-16 md:mb-24">
          <div className="flex items-center space-x-4 mb-2">
            <div className="w-8 h-px bg-black"></div>
            <span className="text-2xl md:text-5xl tracking-[0.3em] text-gray-600 uppercase" style={{ fontWeight: 900 }}>About Us</span>
          </div>
          <div className="pl-12">
            <h2 className="font-extralight text-black tracking-tight" style={{ fontSize: 'clamp(0.85rem, 1.8vw, 1.35rem)' }}>
              私たちについて
            </h2>
          </div>
        </div>

        {/* メインコンテンツ */}
        <div className="grid grid-cols-1 gap-12 md:gap-24 items-center mb-20 md:mb-32">
          <div className="space-y-6 md:space-y-10">
            <p className="font-extralight text-black leading-relaxed tracking-wide">
              <span style={{ color: 'rgba(0,0,0,1)', fontKerning: 'normal' }}>
                <span style={{ fontWeight: 300, fontSize: 'clamp(1.1rem, 4vw, 2.8rem)', display: 'block', lineHeight: 1.1, color: '#4B5563' }}>-CONCEPT&nbsp;-</span>
                <span style={{ fontFamily: '"Noto Serif JP", "Yu Mincho", "YuMincho", "Hiragino Mincho ProN", Georgia, serif', fontWeight: 300, fontSize: 'clamp(1.1rem, 3.5vw, 2.8rem)', display: 'block', lineHeight: 1.3, marginTop: '0.5rem', color: 'rgb(200, 16, 46)', letterSpacing: '0.06em' }}>Exclusive Experience &amp; Hospitality Design</span>
                <span style={{ fontWeight: 400, fontSize: 'clamp(0.88rem, 2.5vw, 1.35rem)', display: 'block', lineHeight: 1.6, marginTop: '0.4rem', color: '#444' }}>富裕層・企業向け：高付加価値イベントの企画・運営プロデュース</span>
              </span>
            </p>
            <div className="w-12 h-px bg-gray-400"></div>
            <p style={{ fontSize: 'clamp(0.95rem, 3vw, 2.4rem)', fontWeight: 600, color: '#4B5563', lineHeight: 1.7, fontFamily: '"Noto Serif JP", "Yu Mincho", "YuMincho", "Hiragino Mincho ProN", Georgia, serif' }}>
              「特別な場所」に、「最高の体験」を吹き込むパートナー
            </p>
            <p style={{ fontSize: 'clamp(0.88rem, 2.5vw, 1.35rem)', fontWeight: 400, color: '#555', lineHeight: 1.8 }}>
              貴重なロケーション（ベニュー）を舞台に、ブランドの格にふさわしい「少人数・高密度」イベントを企画・運営いたします
            </p>
            <p style={{ fontSize: 'clamp(0.88rem, 2.5vw, 1.35rem)', fontWeight: 400, color: '#555', lineHeight: 1.8 }}>
              <strong style={{ fontWeight: 800 }}>Possible：</strong> 企画立案、空間演出、日本文化体験のアレンジ、当日の進行・運営<br /><strong style={{ fontWeight: 800 }}>Preferred project scale：</strong> 10名〜70名程度の、顔が見えるイベント
            </p>
          </div>
        </div>

        {/* 価値観リスト */}
        <div className="space-y-0">
          <div id="services" className="mb-16 md:mb-24">
            <div className="flex items-center space-x-4 mb-2">
              <div className="w-8 h-px bg-black"></div>
              <span className="text-2xl md:text-5xl tracking-[0.3em] text-gray-600 uppercase" style={{ fontWeight: 900 }}>Services</span>
            </div>
            <div className="pl-12">
              <h2 className="font-extralight text-black tracking-tight" style={{ fontSize: 'clamp(0.85rem, 1.8vw, 1.35rem)' }}>
                提供サービス
              </h2>
            </div>
          </div>
          <div className="flex items-center space-x-4 mb-8 md:mb-12">
            <div className="flex flex-col">
              <span style={{ fontWeight: 300, fontSize: 'clamp(1.1rem, 4vw, 2.8rem)', display: 'block', lineHeight: 1.1, color: '#4B5563' }}>-FOUR PILLARS -</span>
            </div>
          </div>
          {values.map((value) => {
            const isExpanded = expandedId === value.number;
            const hasDetails = value.details.length > 0;
            return (
              <div key={value.number} className="border-t border-gray-200">
                <div
                  className="group py-8 md:py-12 cursor-pointer transition-colors duration-500"
                  style={{ backgroundColor: 'transparent' }}
                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#F0EBE0')}
                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                  onClick={() => hasDetails && handleToggle(value.number)}
                >
                  <div className="flex flex-col md:grid md:grid-cols-12 gap-3 md:gap-8 md:items-center">
                    <div className="md:col-span-2 flex md:block items-center gap-4">
                      <span className="text-4xl md:text-5xl font-extralight text-gray-300 group-hover:text-black transition-colors duration-500">
                        {value.number}
                      </span>
                    </div>
                    <div className="md:col-span-5">
                      <h3 className="text-lg md:text-3xl font-light text-black mb-1 group-hover:md:translate-x-4 transition-transform duration-500">
                        {value.title}
                      </h3>
                      <p className="text-xs tracking-[0.2em] uppercase" style={{ color: 'rgb(200, 16, 46)' }}>{value.subtitle}</p>
                    </div>
                    <div className="md:col-span-4">
                      <p className="text-xs md:text-sm font-light text-gray-600 leading-relaxed">{value.description}</p>
                    </div>
                    <div className="md:col-span-1 flex md:justify-end justify-start mt-2 md:mt-0">
                      {hasDetails ? (
                        <div className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center border rounded-full transition-all duration-500 ${isExpanded ? 'bg-black border-black' : 'border-gray-300 group-hover:bg-black group-hover:border-black'}`}>
                          <i className={`text-sm md:text-base transition-all duration-500 ${isExpanded ? 'ri-subtract-line text-white' : 'ri-arrow-right-up-line text-gray-600 group-hover:text-white'}`}></i>
                        </div>
                      ) : (
                        <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center border border-gray-300 rounded-full group-hover:bg-black group-hover:border-black transition-all duration-500">
                          <i className="ri-arrow-right-up-line text-sm md:text-base text-gray-600 group-hover:text-white transition-colors duration-500"></i>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* 展開パネル */}
                {hasDetails && (
                  <div
                    className="overflow-hidden transition-all duration-700 ease-in-out"
                    style={{ maxHeight: isExpanded ? '600px' : '0px', opacity: isExpanded ? 1 : 0 }}
                  >
                    <div className="pb-12 pl-0 md:pl-[calc(100%/6)] pr-4">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {value.details.map((detail, i) => (
                          <div key={i} className="border border-gray-200 p-6 bg-white/60 hover:bg-white transition-colors duration-300">
                            <div className="flex items-start space-x-3 mb-3">
                              <span className="text-xs text-gray-400 font-light mt-1">0{i + 1}</span>
                              <h4 className="text-base font-light text-black tracking-wide">{detail.name}</h4>
                            </div>
                            <p className="text-sm font-light text-gray-500 leading-relaxed pl-6">{detail.text}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          <div className="border-t border-gray-200"></div>
        </div>

      </div>
    </section>
  );
};

export default About;
